import React, { useCallback, useEffect } from "react"
import { string, object } from "yup"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { autoEuropeProviderNormalizationDrawerData, autoEuropeProviderNormalizationDrawerErrors } from "Pages/AutoEuropeTool/ProviderNormalization/@signals"

export default function AutoEuropeProviderNormalizationAutoEuropeProviderField() {
	const value = autoEuropeProviderNormalizationDrawerData.value.autoEuropeProvider ?? ''

	const { errors, isValid } = useValidatorSeeker({ autoEuropeProvider: value }, object({
		autoEuropeProvider: string().required("AutoEurope Provider is required").min(1),
	}))

	useEffect(() => {
		autoEuropeProviderNormalizationDrawerErrors.value = { ...autoEuropeProviderNormalizationDrawerErrors.value, autoEuropeProvider: isValid }
	}, [JSON.stringify(errors)])

	const onChange = useCallback((e) => {
		autoEuropeProviderNormalizationDrawerData.value = { ...autoEuropeProviderNormalizationDrawerData.value, autoEuropeProvider: e.target.value.toUpperCase() }
	}, [])

	return <TextFieldSeeker
		label="AutoEurope Provider"
		value={value}
		onChange={onChange}
		error={errors?.autoEuropeProvider}
	/>
}